exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-categories-list{position:relative}.product-categories-list .indicator{fill:#4ec2ff;position:absolute;top:10px;left:0;opacity:0;transition:opacity .3s}.product-categories-list .indicator.active{opacity:1}.product-categories-list .categs-list{list-style:none;padding:0}@media (min-width:1800px){.product-categories-list .categs-list{min-height:calc(100% - 111px - 134px - 80px - 130px - 50px)}}@media (min-width:1600px) and (max-width:1799px){.product-categories-list .categs-list{min-height:calc(100% - 111px - 128px - 80px - 90px - 50px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/catalog/shared/components/product-categories/product-categories-list.cmp.scss
// module id = 823
// module chunks = 1